export default __webpack_public_path__ + "static/media/php_.94f6fa31.png";